/**
 * InternalName
 *
 * First step collecting an internal campaign name used for organization only.
 */
import React from 'react';
import { Label } from '../../ui/inputs/label';
import { Input } from '../../ui/inputs/input';

export function InternalName({ formData, handleInputChange, aiGeneratedFields }) {
  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="name">Campaign Name *</Label>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Give your campaign a name to help you identify and organize it. This name is for your reference only and won't be shown to users.
        </p>
        <div className="mt-2 flex gap-2">
          <Input
            id="name"
            placeholder="Enter campaign name"
            value={formData.name}
            onChange={handleInputChange}
            autoComplete="off"
            required
            className={`flex-1 transition-all duration-200 ${
              !formData.name?.trim() 
                ? 'ring-2 ring-primary-500/20 border-primary-300 bg-primary-50/30 dark:ring-primary-400/20 dark:border-primary-400 dark:bg-primary-900/20' 
                : 'ring-0'
            }`}
          />
        </div>
        <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
          Tip: Make it unique amongst your campaigns so you can identify it later
        </p>
      </div>
    </div>
  );
}